import React from 'react';
import { Flex, Text } from 'pounceV2';
import { useTheme } from '@mui/material';
import CollapsibleTextV3 from './CollapsibleTextV3';

interface CollapsibleFieldV3Props {
  label: string;
  value: string;
}

const CollapsibleFieldV3: React.FC<CollapsibleFieldV3Props> = ({ label, value }) => {
  const {
    palette: { tokens },
  } = useTheme();
  const [expanded, setExpanded] = React.useState(false);

  return (
    <Flex direction="column" gap={1}>
      <Text variant="label/sm" color={tokens.content.text.neutral[3]}>
        {label}
      </Text>
      <CollapsibleTextV3 expanded={expanded} onExpandChange={setExpanded}>
        <Text as="span" variant="body/sm" color={tokens.content.text.neutral.base}>
          {value}
        </Text>
      </CollapsibleTextV3>
    </Flex>
  );
};

export default CollapsibleFieldV3;
